import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet-async";
import { FlexRow } from "../../../styles/styled-components-utils";
import checkAuthz from "../../../util/authz";
import CheckUnauth from "../../auth/CheckUnauth";
import AddGoogleIDs from "./AddGoogleIDs";
import AnalyticsDashboard from "./AnalyticsDashboard";
import ManagePopups from "./ManagePopups";
import SendAccountInvitations from "./SendAccountInvitations";
import AdHocSearchReports from "./AdHocSearchReports";
import MyLists from "../MyLists";
import { useLocation } from "react-router-dom";

const FlexContainer = styled(FlexRow)`
  height: 100%;
  align-content: flex-start;
  flex-wrap: wrap;
  flex-grow: 1;
  position: relative;
`;

const TabBar = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 2px solid var(--color-primary, darkgreen);
  gap: 2px;
  overflow-x: auto;
`;

const Tab = styled.div`
  padding: 0.5em 1.2em;
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.95em;
  border-radius: 8px 8px 0 0;
  border: 2px solid var(--color-primary, darkgreen);
  border-bottom: none;
  margin-bottom: -2px;
  background: ${(props) =>
    props.selected === props.index ? "white" : "transparent"};
  font-weight: ${(props) => (props.selected === props.index ? "600" : "400")};
  color: ${(props) =>
    props.selected === props.index
      ? "var(--color-primary, darkgreen)"
      : "inherit"};
  display: ${(props) =>
    !checkAuthz(props.token, props.groups) ? "none" : "flex"};
  align-items: center;
  transition: background 0.15s;

  &:hover {
    background: ${(props) =>
      props.selected === props.index ? "white" : "rgba(0,100,0,0.05)"};
  }
`;

const TabBody = styled.div`
  display: flex;
  width: 100%;
  padding-top: 1em;
  ${(props) => {
    if (!checkAuthz(props.token, props.groups)) {
      return `display: none;`;
    }
  }}
`;

const AdminMainPage = ({ token }) => {
  const location = useLocation();
  const hash = location.hash;
  // Default to My Lists tab for regular users
  const [selected, setSelected] = useState(hash ? parseInt(hash[1]) : 6);
  const isAdmin = checkAuthz(token, ["admin"]);

  const renderSwitch = () => {
    switch (selected) {
      case 6:
        return (
          <TabBody token={token} groups={[]}>
            <MyLists />
          </TabBody>
        );
      case 3:
        return (
          <TabBody token={token} groups={[]}>
            <ManagePopups token={token} />
          </TabBody>
        );
      case 1:
        return (
          <TabBody token={token} groups={["admin"]}>
            <AddGoogleIDs />
          </TabBody>
        );
      case 2:
        return (
          <TabBody token={token} groups={["admin"]}>
            <div>
              <SendAccountInvitations />
            </div>
          </TabBody>
        );
      case 4:
        return (
          <TabBody token={token} groups={["admin"]}>
            <AnalyticsDashboard />
          </TabBody>
        );
      case 5:
        return (
          <TabBody token={token} groups={["admin"]}>
            <AdHocSearchReports token={token} location={location} />
          </TabBody>
        );
      default:
        return (
          <TabBody token={token} groups={[]}>
            <MyLists />
          </TabBody>
        );
    }
  };

  return (
    <Fragment>
      <Helmet>
        <title>My Profile | VegifyIt</title>
      </Helmet>
      <CheckUnauth {...location} />
      <FlexContainer>
        <TabBar>
          {/* User-facing tabs first */}
          <Tab
            index={6}
            selected={selected}
            token={token}
            groups={[]}
            onClick={() => setSelected(6)}
          >
            <i className="fas fa-bookmark" style={{ marginRight: "6px" }} />
            My Lists
          </Tab>
          <Tab
            index={3}
            selected={selected}
            token={token}
            groups={[]}
            onClick={() => setSelected(3)}
          >
            <i className="fas fa-utensils" style={{ marginRight: "6px" }} />
            My Restaurants
          </Tab>
          <Tab
            index={4}
            selected={selected}
            token={token}
            groups={["admin"]}
            onClick={() => setSelected(4)}
          >
            <i
              className="fas fa-chart-bar"
              style={{ marginRight: "6px" }}
            />
            Analytics
          </Tab>
          {/* Admin-only tabs */}
          <Tab
            index={1}
            selected={selected}
            token={token}
            groups={["admin"]}
            onClick={() => setSelected(1)}
          >
            Add Google IDs
          </Tab>
          <Tab
            index={2}
            selected={selected}
            token={token}
            groups={["admin"]}
            onClick={() => setSelected(2)}
          >
            Invitations
          </Tab>
          <Tab
            index={5}
            selected={selected}
            token={token}
            groups={["admin"]}
            onClick={() => setSelected(5)}
          >
            Ad Hoc Reports
          </Tab>
        </TabBar>
        {renderSwitch()}
      </FlexContainer>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
});
export default connect(mapStateToProps, {})(AdminMainPage);
